import React from "react";
import styled from "styled-components";
import {
  FlexibleContainer,
  RowContainer,
} from "../containers/styledComponents";
import { greyText, lightGreys } from "../../styles";
import { CompassParagraph } from "../common/styledComponents";

export const HeaderRow = styled(RowContainer)`
  justify-content: space-between;
  padding-bottom: 7px;
  border-bottom: 1px solid ${lightGreys.borderLightGrey};
  background-color: ${lightGreys.KPIBackground};
  padding: 20px 10px;
`;

const DataEntryRow = styled(RowContainer)`
  align-items: center;
  justify-content: space-between;
  padding-bottom: 4px;
  border-bottom: 1px solid ${lightGreys.borderLightGrey};
  padding: 6px 10px;
`;

const TableColumn = styled.div<{ widthPercentage?: number }>`
  width: ${({ widthPercentage }): string =>
    widthPercentage ? `${widthPercentage}%` : "auto"};
`;

export type Column = {
  title: string;
  widthPercentage?: number;
};

export type DataEntry = {
  [key: string]: React.ReactNode;
};

export const FlexibleTable: React.FC<{
  columns: Column[];
  data: DataEntry[];
}> = ({ columns, data }) => {
  return (
    <FlexibleContainer fd="column" w={"100%"} p={"10px 5px"} ofy="auto">
      <HeaderRow>
        {columns.map((column, index) => (
          <TableColumn key={index} widthPercentage={column.widthPercentage}>
            <CompassParagraph color={greyText} bold={true}>
              {column.title}
            </CompassParagraph>
          </TableColumn>
        ))}
      </HeaderRow>
      {data.map((entry, rowIndex) => (
        <DataEntryRow key={rowIndex}>
          {columns.map((column, colIndex) => (
            <TableColumn
              key={colIndex}
              widthPercentage={column.widthPercentage}
            >
              {React.isValidElement(entry[column.title]) ? (
                entry[column.title]
              ) : (
                <CompassParagraph fontSize={12}>
                  {entry[column.title]?.toString()}
                </CompassParagraph>
              )}
            </TableColumn>
          ))}
        </DataEntryRow>
      ))}
    </FlexibleContainer>
  );
};
